var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.81475C1 3.53148 1 2.88985 1.39866 2.49119C1.79732 2.09253 2.43895 2.09253 3.72222 2.09253C5.00549 2.09253 5.64712 2.09253 6.04578 2.49119C6.44444 2.88985 6.44444 3.53148 6.44444 4.81475C6.44444 6.09802 6.44444 6.73965 6.04578 7.13831C5.64712 7.53697 5.00549 7.53697 3.72222 7.53697C2.43895 7.53697 1.79732 7.53697 1.39866 7.13831C1 6.73965 1 6.09802 1 4.81475Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999756 12.9815L2.17294 14.1547C2.5273 14.509 3.10184 14.509 3.4562 14.1547L6.4442 11.1667M10.0738 3H14.9998M10.0738 8.44445H14.9998M10.0738 13.8889H14.9998",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckList);
export default __webpack_public_path__ + "static/media/checkList.5825bc7988ab4934bfadf36e75af4904.svg";
export { ForwardRef as ReactComponent };